import * as React from 'react';
import { Drawer, List } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import SearchInput from './SearchInput';
import { selectKeyword, selectResults, setResults } from '../store';
import ResultContent from './ResultContent';

interface ISearchResultsProps {
}

const SearchResults: React.FC<ISearchResultsProps> = props => {

    const keyword = useSelector(selectKeyword);
    const results = useSelector(selectResults);

    const dispatch = useDispatch();

    return <Drawer placement='right'
        mask={false}
        width={'30vw'}
        visible={!!results} onClose={e => {
            dispatch(setResults(undefined))
    }}>
        <div style={{
            width: '80%',
            height: '3em',
            position: 'absolute',
            background: '#FFF',
            zIndex: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        }}>
            <SearchInput/>
        </div>
        <List
            style={{top: '3em'}}
            dataSource={results}
            renderItem={(result, index) => (
                <List.Item>
                    <List.Item.Meta
                        title={<NavLink to={result.to}>{result.title}</NavLink>}
                        description={<ResultContent content={result.content} keyword={keyword} />}
                    />
                </List.Item>
            )}
        />
    </Drawer>;
}

export default SearchResults;